import type NotificationEntities from '../../../contracts/NotificationEntities';
import type { EmailNotificationSettings } from '../../../contracts';
import * as types from './types';

export const fetchNotificationsBegin = () => ({
  type: types.FETCH_NOTIFICATIONS_BEGIN
});

export const fetchNotificationsSuccess = (payload: NotificationEntities) => ({
  type: types.FETCH_NOTIFICATIONS_SUCCESS,
  payload
});

export const fetchNotificationsFailure = (error: unknown) => ({
  type: types.FETCH_NOTIFICATIONS_FAILURE,
  payload: error
});

export const fetchSoftpullConsentBegin = () => ({
  type: types.FETCH_SOFTPULL_CONSENT_BEGIN
});

export const fetchSoftpullConsentSuccess = (payload: boolean) => ({
  type: types.FETCH_SOFTPULL_CONSENT_SUCCESS,
  payload
});

export const fetchSoftpullConsentFailure = (error: unknown) => ({
  type: types.FETCH_SOFTPULL_CONSENT_FAILURE,
  payload: error
});

export const updateEmailNotificationsBegin = () => ({
  type: types.UPDATE_EMAIL_NOTIFICATIONS_BEGIN
});

export const updateEmailNotificationsSuccess = (payload: EmailNotificationSettings) => ({
  type: types.UPDATE_EMAIL_NOTIFICATIONS_SUCCESS,
  payload
});

export const updateEmailNotificationsFailure = (payload: {
  error: unknown;
  emailOriginalState: EmailNotificationSettings;
}) => ({
  type: types.UPDATE_EMAIL_NOTIFICATIONS_FAILURE,
  payload
});

export const updateTCPANotificationsBegin = () => ({
  type: types.UPDATE_TCPA_NOTIFICATIONS_BEGIN
});

export const updateTCPANotificationsSuccess = (payload: boolean) => ({
  type: types.UPDATE_TCPA_NOTIFICATIONS_SUCCESS,
  payload
});

export const updateTCPANotificationsFailure = (error: unknown) => ({
  type: types.UPDATE_TCPA_NOTIFICATIONS_FAILURE,
  payload: error
});

export const updateCreditMonitoringConsentBegin = () => ({
  type: types.UPDATE_CREDIT_MONITORING_CONSENT_BEGIN
});

export const updateCreditMonitoringConsentSuccess = (payload: boolean) => ({
  type: types.UPDATE_CREDIT_MONITORING_CONSENT_SUCCESS,
  payload
});

export const updateCreditMonitoringConsentFailure = (error: unknown) => ({
  type: types.UPDATE_CREDIT_MONITORING_CONSENT_FAILURE,
  payload: error
});
